var ProductTypes;
(function (ProductTypes) {
    ProductTypes["EMAIL"] = "EMAIL";
    ProductTypes["CINEMA"] = "CINEMA";
    ProductTypes["SINGLE_PRODUCT"] = "SINGLE_PRODUCT";
    ProductTypes["SINGLE_PRODUCT_QUANTITY"] = "SINGLE_PRODUCT_QUANTITY";
    ProductTypes["MULTIPLE_PRODUCTS"] = "MULTIPLE_PRODUCTS";
    ProductTypes["OPEN_VALUE_PRODUCT"] = "OPEN_VALUE_PRODUCT";
    ProductTypes["PAYMENT"] = "PAYMENT";
    ProductTypes["BIRTHDAY_BOX"] = "BIRTHDAY_BOX";
})(ProductTypes || (ProductTypes = {}));
export default ProductTypes;
